var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new-label-container"},[_c('ItemEditor',{ref:"input",staticClass:"new-label",attrs:{"value":_vm.newLabelName,"isLabel":true,"placeholder":"settings.permissions.user-labels.label-input-placeholder"},on:{"cancel":_vm.cancelNewLabelInput,"edit":_vm.addNewLabel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }